import { useEffect, useRef } from 'react';

// copied from https://overreacted.io/making-setinterval-declarative-with-react-hooks/

type CallbackFunction = () => void | undefined;
type Delay = number | null;

const useInterval = (callback: CallbackFunction, delay: Delay) => {
  const savedCallback = useRef<CallbackFunction>(callback);

  // Remember the latest callback.
  useEffect(() => {
    savedCallback.current = callback;
  }, [callback]);

  // Set up the interval.
  useEffect(() => {
    function tick() {
      if (savedCallback.current) {
        savedCallback.current();
      }
    }
    if (delay !== null) {
      const id = setInterval(tick, delay);
      return () => clearInterval(id);
    }
  }, [delay]);
};

export default useInterval;
